import { wasteYardsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { rangeFilterUTC } from "../helpers/utils";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("waste-yards"),
  endpoint: "waste-yards",
  operations: wasteYardsOps,
  roleView: [ROLE.CUSTOMER_VIEW],
  roleAdmin: [ROLE.CUSTOMER_ADMIN],
  baseRoute: "waste-yards",
  singularName: (t) => t("Waste yard"),
  name: (t) => t("Waste yards"),

  sendCulture: true,
  initialFilter: {},
  filterFormatter: rangeFilterUTC,
  syncCustomerFilter: true,
});

export default conf;
